export default __webpack_public_path__ + "static/media/three.62b6d81f.png";